module.exports = __webpack_public_path__ + "assets/img/pfour.0effcf07.png";